import { useMemo } from "react";
import { Cell, useBlockLayout, useTable } from "react-table";
import { ContractCreditBucket } from "src/api/credit/credit-types";
import { numberToStringWithComma } from "src/utils";

// 금액 포맷 (없으면 "-")
const fmt = (v?: number | string) => (v !== undefined && v !== null ? numberToStringWithComma(Number(v)) : "-");

/**
 * 지급/회수 모달 내 '충전금 현황' 테이블 (월별 충전금 내역과 동일한 base-table 스타일)
 * - 현재 버킷 1행, 6개 금액 컬럼 (관리/내역·정산년월 제외)
 */
const CreditStatusTable = ({ bucket }: { bucket: ContractCreditBucket }) => {
  const columns = useMemo<Array<any>>(
    () => [
      { Header: "총 충전금", accessor: "chargedCredit", width: 130, Cell: ({ value }: Cell<ContractCreditBucket>) => <p className="w-100 text-right">{fmt(value)}</p> },
      { Header: "사용 충전금 (확정)", accessor: "confirmedCredit", width: 150, Cell: ({ value }: Cell<ContractCreditBucket>) => <p className="w-100 text-right">{fmt(value)}</p> },
      { Header: "사용 충전금 (예정)", accessor: "scheduledCredit", width: 150, Cell: ({ value }: Cell<ContractCreditBucket>) => <p className="w-100 text-right">{fmt(value)}</p> },
      {
        Header: "잔여 충전금",
        accessor: "remainingCredit",
        width: 140,
        Cell: ({ value }: Cell<ContractCreditBucket>) => <p className="w-100 text-right font-weight-medium">{fmt(value)}</p>,
      },
      { Header: "청구 대상 요금 (확정)", accessor: "confirmedAmount", width: 185, Cell: ({ value }: Cell<ContractCreditBucket>) => <p className="w-100 text-right">{fmt(value)}</p> },
      { Header: "청구 대상 요금 (예정)", accessor: "scheduledAmount", width: 185, Cell: ({ value }: Cell<ContractCreditBucket>) => <p className="w-100 text-right">{fmt(value)}</p> },
    ],
    [],
  );

  const data = useMemo(() => [bucket], [bucket]);
  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows } = useTable({ columns, data }, useBlockLayout);

  return (
    <div className="base-table-wrap pl0" style={{ paddingRight: 0 }}>
      <div {...getTableProps()} className="base-table sticky">
        <div className="header">
          {headerGroups.map((headerGroup) => (
            <div {...headerGroup.getHeaderGroupProps()} className="base-table__tr">
              {headerGroup.headers.map((header) => (
                <div {...header.getHeaderProps()} className="base-table__th">
                  {header.render("Header")}
                </div>
              ))}
            </div>
          ))}
        </div>
        <div {...getTableBodyProps()} className="body">
          {rows.map((row) => {
            prepareRow(row);
            return (
              <div {...row.getRowProps()} className="base-table__tr">
                {row.cells.map((cell) => (
                  <div {...cell.getCellProps()} className="base-table__td">
                    {cell.render("Cell")}
                  </div>
                ))}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CreditStatusTable;
